import { IMedia } from 'src/utils/Interfaces/media.interface'
import { MediaItem } from '../MediaItem'
import style from './style.module.scss'

interface Props {
  data: IMedia[] | undefined
  isLoading: boolean
}

export const MediaList = ({ data, isLoading }: Props) => {
  return (
    <ul className={style.media_list}>
      <li className={style.titles}>
        <span>File</span>
        <span>Type</span>
        <span>Extension</span>
        <span>Size</span>
        <span>Created</span>
        <span>URL</span>
        <span></span>
      </li>
      {isLoading && <li>Loading...</li>}
      {data?.map((item) => <MediaItem key={item.id} item={item} />)}
    </ul>
  )
}
